/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Spinner } from "@atomic/ui-kit";
import { type FC } from "react";

/** The wait while a lazy route's chunk arrives: the kit's loading mark. */
export const PageLoader: FC = () => (
  <div
    css={css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      min-height: 200px;
    `}
  >
    <Spinner size={32} />
  </div>
);
